module.exports = __webpack_public_path__ + "static/images/details-4.e0197fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/ssk/details-4.png
// module id = Tljp
// module chunks = 0